module.exports = __webpack_public_path__ + "img/vuejs.797af447.svg";